import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      style={{
        border: '1px solid #ccc',
        background: copied ? '#4caf50' : '#f0f0f0',
        color: copied ? '#fff' : '#333',
        padding: '4px 10px',
        fontSize: '13px',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'all 0.3s',
        whiteSpace: 'nowrap',
      }}
    >
      {copied ? 'Copied!' : 'Copy'}
    </button>
  );
};

const Affiliate = () => {
  const [affiliateData, setAffiliateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showWithdrawForm, setShowWithdrawForm] = useState(false);
  const [isAffiliator, setIsAffiliator] = useState(true);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [message, setMessage] = useState('');

  const customerId = localStorage.getItem('customer_id');

  useEffect(() => {
    const fetchAffiliateData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/affiliator-stats/${customerId}`);
        if (response.data.success) {
          setAffiliateData(response.data.data);
        } else {
          setIsAffiliator(false);
        }
      } catch (error) {
        console.error('API error:', error);
        setIsAffiliator(false);
      } finally {
        setLoading(false);
      }
    };

    if (customerId) {
      fetchAffiliateData();
    } else {
      setIsAffiliator(false);
      setLoading(false);
    }
  }, [customerId]);

  const handleWithdrawSubmit = (e) => {
    e.preventDefault();
    if (withdrawAmount) {
      setMessage('Withdraw request submitted.');
      setWithdrawAmount('');
      setTimeout(() => setMessage(''), 3000);
    }
  };

  if (loading) return <p className="text-center py-10">Loading...</p>;

  if (!isAffiliator) {
    return (
      <div className="text-center py-10">
        <h2 className="text-xl font-semibold mb-4">You are not an affiliator yet.</h2>
        <button className="btn-default px-4 py-2 border rounded-md">Apply as Affiliator</button>
      </div>
    );
  }

  // Base URLs and their titles
  const baseUrls = [
    'https://localhost:3005/trainer',
    'https://localhost:3005/consultent',
    'https://localhost:3005/speaker',
    'https://localhost:3005/course',
    'https://localhost:3005/content',
    'https://localhost:3005/community',
    'https://localhost:3005/audit',
  ];

  const titles = [
    'Trainer',
    'Consultent',
    'Speaker',
    'Course',
    'Content',
    'Community',
    'Audit',
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-10">

      {/* Balance & Withdraw Button */}
      <div className="flex flex-col sm:flex-row justify-between items-center rounded-lg p-4 mb-5">
        <div>
          <h2 className="text-2xl font-semibold">Affiliate Balance</h2>
          <h4 className="text-lg font-bold mt-1" style={{ color: "#fb5343" }}>৳{affiliateData.balance}</h4>
        </div>
        <button
          onClick={() => setShowWithdrawForm(!showWithdrawForm)}
          className="btn-default"
        >
          {showWithdrawForm ? 'Cancel Withdraw' : 'Request Withdraw'}
        </button>
      </div>

      {/* Withdraw Form */}
      {showWithdrawForm && (
        <form
          onSubmit={handleWithdrawSubmit}
          style={{
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '10px',
            // border: '1px solid #e5e7eb',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
          }}
        >
          <input
            type="number"
            placeholder="Withdraw Amount"
            value={withdrawAmount}
            onChange={(e) => setWithdrawAmount(e.target.value)}
            required
            style={{
              padding: '8px 12px',
              borderRadius: '6px',
              border: '1px solid #d1d5db',
              width: '250px',
            }}
          />
          <button type="submit" className="btn-default">Submit</button>
          {message && <p style={{ color: 'green', fontSize: '14px', marginLeft: '8px' }}>{message}</p>}
        </form>
      )}



      {/* Sell History Table */}
      <div className='mb-5 mt-5'>
        <h3 className="text-lg font-semibold mb-3">Sell History</h3>
        <div className="border rounded-lg shadow-sm overflow-x-auto">
          <table className="min-w-full table-auto text-sm">
            <thead className="bg-gray-50 text-gray-700 font-semibold">
              <tr>
                <th className="px-4 py-3 text-left">Email</th>
                <th className="px-4 py-3 text-left">Service</th>
                <th className="px-4 py-3 text-left">Package</th>
                <th className="px-4 py-3 text-left">Amount</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Created</th>
              </tr>
            </thead>
            <tbody>
              {affiliateData.sells.map((order, idx) => (
                <tr key={idx} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2">{order.email}</td>
                  <td className="px-4 py-2">{order.service}</td>
                  <td className="px-4 py-2">{order.package}</td>
                  <td className="px-4 py-2">৳{order.amount}</td>
                  <td className="px-4 py-2">
                    <span className={`text-xs px-2 py-1 rounded-full ${order.status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                      {order.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">{order.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Withdraw History Table */}
      <div className='mt-5 mb-5 pb-5 mb-5'>
        <h3 className="text-lg font-semibold mb-3">Withdraw History</h3>
        <div className="border rounded-lg shadow-sm overflow-x-auto">
          <table className="min-w-full table-auto text-sm">
            <thead className="bg-gray-50 text-gray-700 font-semibold">
              <tr>
                <th className="px-4 py-3 text-left">Withdraw ID</th>
                <th className="px-4 py-3 text-left">Amount</th>
                <th className="px-4 py-3 text-left">Status</th>
                <th className="px-4 py-3 text-left">Requested At</th>
              </tr>
            </thead>
            <tbody>
              {affiliateData.withdrawals.map((withdrawal, idx) => (
                <tr key={idx} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2">{withdrawal.withdrawal_id}</td>
                  <td className="px-4 py-2">৳{withdrawal.amount}</td>
                  <td className="px-4 py-2">
                    <span className={`text-xs px-2 py-1 rounded-full ${withdrawal.status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                      {withdrawal.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">{withdrawal.requested_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className='mt-5'>
        <h3 className='text-center'>Your Affiliation Link</h3>
      </div>
      {/* Affiliate Links in 7 Rows */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }} className='p-5'>
        {baseUrls.map((baseUrl, i) => {
          const affiliateLink = `${baseUrl}/?affiliator=${affiliateData.affiliator_id}`;

          return (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                // border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '12px',
                // background: '#fff',
              }}
            >
              <div style={{ minWidth: '110px', fontWeight: '600' }}>
                {titles[i]}
              </div>
              <input
                type="text"
                readOnly
                value={affiliateLink}
                style={{
                  flex: 1,
                  padding: '8px',
                  fontSize: '14px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  // background: '#fafafa',
                  // color: '#333',
                  userSelect: 'all',
                }}
                onFocus={(e) => e.target.select()}
              />
              <CopyButton text={affiliateLink} />
            </div>
          );
        })}
      </div>

    </div>
  );
};

export default Affiliate;
